import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { SettingsPage } from '@/features/service-agreements/settings-page';

/** The agreement-type rules. Reading them requires `service-config:read`; saving `:write`. */
export const Route = createFileRoute('/_app/service-agreement/settings')({
  staticData: { featureKey: 'service-agreements' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'service-agreements',
      permissions: ['service-config:read'],
    }),
  component: SettingsPage,
});
